export default __webpack_public_path__ + "static/media/AmiyaBagchi.ac031e43.png";